<template>
  <div class="page_openPlatform">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目:">
              <el-select v-model="listQuery.projects" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对接名称" size="small">
              <el-input v-model="listQuery.dockingName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.initiateMode" placeholder="" clearable filterable style="width:180px">
                <el-option label="启用" :value="true"></el-option>
                <el-option label="禁用" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>开放平台</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName=='0' ? '商户对接' : activeName=='0' ? 'API接口' : '项目定制数据' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="商户对接" name="0"></el-tab-pane>
          <el-tab-pane label="API接口" name="1"></el-tab-pane>
          <el-tab-pane label="项目定制数据" name="2"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addDocking" v-if="activeName=='0'">新增对接</el-button>
          <el-button type="success" size="small" @click="addCustom" v-if="activeName=='2'">新增定制</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
          <el-table-column key="0" label="序号" min-width="100" align="center">
            <template slot-scope="{$index}">{{ (listQuery.PageModel.Page - 1) * listQuery.PageModel.Rows + $index + 1 }}</template>
          </el-table-column>
          <template v-if="activeName=='0'">
            <el-table-column prop="dockingName" key="1" label="对接名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="appInter" key="2" label="适用接口" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projects" key="3" label="适用项目" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="appId" key="4" label="appId" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="appKey" key="5" label="appKey" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" key="6" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="initiateMode" key="7" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.initiateMode ? '启用' : '禁用' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="editHandel(row)">编辑</el-button>
                  <el-button type="text" size="small" @click="stopHandel(row)">{{row.initiateMode ? '禁用' : '启用'}}</el-button>
                  <el-popconfirm title="请确定是否删除" @confirm="del(row)">
                    <el-button type="text" slot="reference" style="margin-left: 10px;">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName=='1'">
            <el-table-column prop="fileName" key="1" label="接口名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" key="2" label="类别" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="fileUrl" key="3" label="备注" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="100" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="getDtl(row)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName=='2'">
            <el-table-column prop="setName" key="1" label="定制名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="appInter" key="2" label="类别" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="projectName" key="3" label="适用项目" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="customField" key="4" label="定制字段" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" key="5" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="initiateMode" key="6" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.initiateMode ? '启用' : '禁用' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="toDtl(row)">详情</el-button>
                  <el-button type="text" size="small">编辑</el-button>
                  <el-popconfirm title="请确定是否删除" @confirm="del(row)">
                    <el-button type="text" slot="reference" style="margin-left: 10px;">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增对接-->
    <el-dialog :title="type=='add' ? '新增对接' : '修改'" :visible.sync="addDockingVisible" width="450px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="statementForm" :model="dockingForm" class="" label-width="100px" size="small">
        <!-- <el-form-item label="对接类型" prop="name">
          <el-select v-model="dockingForm.name" placeholder="" clearable filterable style="width:300px">
            <el-option value="对接客户接口"></el-option>
            <el-option value="对接我方接口"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="对接名称" prop="dockingName">
          <el-input v-model="dockingForm.dockingName" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="适用接口" prop="name">
          <el-select v-model="appInter" placeholder="" multiple clearable filterable style="width:300px">
            <el-option v-for="(item,index) in interfaceList" :key="index" :label="item.fileName" :value="item.fileName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用项目:" prop="projectId">
          <el-select v-model="projects" placeholder="" style="width:300px" multiple filterable clearable>
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDockingVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddDocking" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增定制-->
    <el-dialog :title="type=='add' ? '新增定制' : '修改'" :visible.sync="addCustomVisible" width="450px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="customForm" :model="customForm" class="" label-width="100px" size="small">
        <el-form-item label="定制名称" prop="dockingName">
          <el-input v-model="customForm.setName" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="适用项目:" prop="projectId">
          <el-select v-model="projects" placeholder="" style="width:300px" multiple filterable clearable>
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="dockingName">
          <el-input v-model="customForm.remark" size="small" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCustomVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddCustom" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 接口详情-->
    <el-dialog title="详情" :visible.sync="showDtl" width="600px" class="res_dialog enter_dialog">
      <el-table :data="dtlData" border class="doc_table" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
        <el-table-column label="序号" min-width="60" align="center">
          <template slot-scope="{$index}">{{ $index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="creater" key="1" label="类型" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="fileUrl" key="2" label="字段名称" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="fileName" key="2" label="字段参数" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDtl = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    create,
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          initiateMode: null,
          dockingName: "",
          projects: ""
        },
        dockingForm: {
          id: '',
          appKey: '', //私钥
          appId: '', //公钥
          dockingName: '', //对接名称
          appInter: '',
          projects: '',
          remark: '',
          initiateMode: true, //启用状态
          appInterDic: [{ //适用接口
            id: '',
            val: ''
          }],
          projectsDic: [{ //适用项目
            id: '',
            val: ''
          }]
        },
        appInter: [],
        projects: [],
        type: '',
        fileList: [],
        addDockingVisible: false,
        isbtnLoading: false,
        activeName: '0',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        permissionLists: [],
        rules: {},
        interfaceList: [], //适用接口列表
        addCustomVisible: false,
        customForm: {
          id: '',
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          setName: '', //对接名称
          projectName: '',
          customField: '', //定制字段
          remark: '',
          initiateMode: true,
          projectsDic: [{
            id: '',
            val: ''
          }]
        },
        showDtl: false,
        dtlData: [],
      }
    },
    created() {
      this.getProList();
      this.getList();
      this.GetSocialSecurityFundPageList(); //获取适用接口列表
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      GetSocialSecurityFundPageList() {
        let d = {
          PageModel: {
            Rows: 1000,
            Page: 1,
            OrderInput: []
          },
          fileName: '',
          busiType: 3,
          busiId: ''
        }
        xz.ArdCurStat(d, 'GetSocialSecurityFundPageList').then(res => {
          if (res.status == 'ok') {
            this.interfaceList = res.data.data;
          } else {
            this.interfaceList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        let pagename = '';
        if (this.activeName == '0') {
          pagename = 'GetMerchantDockingList'
        } else if (this.activeName == '1') {
          pagename = 'GetSocialSecurityFundPageList'
        } else if (this.activeName == '2') {
          pagename = 'GetProjectSetList'
        }
        this.loading = true;
        xz.ArdCurStat(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      getDtl(row) {
        let d = {
          PageModel: {
            Rows: 100,
            Page: 1,
            OrderInput: []
          },
          fileName: '',
          busiType: 4,
          busiId: row.id
        }
        xz.ArdCurStat(d, 'GetSocialSecurityFundPageList').then(res => {
          if (res.status == 'ok') {
            this.showDtl = true;
            this.dtlData = res.data.data;
          } else {
            this.$message.error(res.msg)
            this.dtlData = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            initiateMode: true,
            dockingName: "",
            projects: ""
          }
        } else if (this.activeName == '1') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            fileName: '',
            busiType: 3,
            busiId: ''
          }
        } else if (this.activeName == '2') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            initiateMode: true,
            setName: "",
            projects: ""
          }
        }
        this.getList()
      },
      changePro(val) {},
      //新增对接
      addDocking() {
        this.dockingForm = {
          id: '',
          appKey: '', //私钥
          appId: '', //公钥
          dockingName: '', //对接名称
          appInter: '',
          projects: '',
          remark: '',
          initiateMode: true, //启用状态
          appInterDic: [],
          projectsDic: []
        }
        this.appInter = [];
        this.projects = [];
        this.type = 'add';
        this.isbtnLoading = false;
        this.addDockingVisible = true;
      },
      editHandel(row) {
        this.type = 'edit';
        this.dockingForm = {
          id: row.id,
          appKey: row.appKey, //私钥
          appId: row.appId, //公钥
          dockingName: row.dockingName, //对接名称
          appInter: row.appInter,
          projects: row.projects,
          remark: row.remark,
          initiateMode: true, //启用状态
          appInterDic: [],
          projectsDic: []
        }
        this.appInter = row.appInter.split(',')
        this.projects = row.projects.split(',')
        this.isbtnLoading = false;
        this.addDockingVisible = true;
      },
      confirmAddDocking() {
        this.isbtnLoading = true;
        this.appInter.forEach(ele => {
          let item = this.interfaceList.find(e => ele == e.fileName);
          let d = {
            id: item.id,
            val: item.fileName
          }
          this.dockingForm.appInterDic.push(d)
        });
        this.projects.forEach(ele => {
          let item = this.projectList.find(e => ele == e.StrprojectName);
          let d = {
            id: item.Projectid,
            val: item.StrprojectName
          }
          this.dockingForm.projectsDic.push(d)
        });
        xz.ArdCurStat(this.dockingForm, 'AddUpdataDellMerchantDocking').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功')
            this.getList();
            this.addDockingVisible = false;
            this.isbtnLoading = false;
          } else {
            this.$message.error(res.msg)
            this.isbtnLoading = false;
          }
        })
      },
      //作废
      del(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataDellMerchantDocking').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.addDockingVisible = false;
            this.$message.success("作废成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      stopHandel(row) {
        let d = {
          id: row.id,
          initiateMode: !row.initiateMode
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataDellMerchantDocking').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.addDockingVisible = false;
            this.$message.success("操作成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      addCustom() {
        this.customForm = {
          id: '',
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          setName: '', //对接名称
          projectName: '',
          customField: '', //定制字段
          remark: '',
          initiateMode: true,
          projectsDic: []
        }
        this.projects = [];
        this.type = 'add';
        this.isbtnLoading = false;
        this.addCustomVisible = true;
      },
      confirmAddCustom() {
        if (this.projects.length > 0) {
          this.projects.forEach(ele => {
            let item = this.projectList.find(e => ele == e.StrprojectName);
            let d = {
              id: item.Projectid,
              val: item.StrprojectName
            }
            this.customForm.projectsDic.push(d)
          });
          xz.ArdCurStat(this.customForm, 'AddUpdataDellProjectSet').then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功')
              this.getList();
              this.addCustomVisible = false;
              this.isbtnLoading = false;
            } else {
              this.$message.error(res.msg)
              this.isbtnLoading = false;
            }
          })
        } else {
          this.$message.warning('请选择适用项目')
        }
      },
      toDtl(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/customDtl",
          query: {
            id: row.id
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }
</style>
<style>
  .page_openPlatform .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_openPlatform .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_openPlatform .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_openPlatform .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_openPlatform .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_openPlatform .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>